import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import CollectionPage from "@/pages/collection/page";
import ArticlePage from "@/pages/article/page";
import About from "@/pages/about/page";
import Faq from "@/pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:slug", element: <CategoryPage /> },
      { path: "collection/:slug", element: <CollectionPage /> },
      { path: "article/:slug", element: <ArticlePage /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <Faq /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;